/* eslint-disable no-use-before-define */
import React from 'react'
import { ajax, Status, arrayFrom, NO_RESULT_ICON_HTML } from '../../twd/twd'

const NO_RESULT = `
    <div class="text-center text-body">${NO_RESULT_ICON_HTML}
    <br/>
    <h4 class="small-header">No offerings available</h4>
    No offerings align with your search criteria. Please try an alternate search.
    </div>
`

export default ({activeState}) => {

    const [status, setStatus] = React.useState(Status.LOADING)
    const [error, setError] = React.useState('')
    const [offersData, setOffersData] = React.useState({})

    const lastAbort = React.useRef()

    React.useEffect(() => {
        ;(async () => {
        try {
            setError('')
            setStatus(Status.LOADING)
            if (lastAbort.current) lastAbort.current()

            let { data, abort } = await ajax({
                url: '/esb/retailservice/yieldCurveService/getScatterGraphOfferingSearchData',
                method: 'POST',
                params: {
                    bondType: 'MUNI',
                    muniType: 'GO',
                    marketSnapshotType: 'MUNI_GO_SCATTER_GRAPH_DATA',
                    maxYield: 20,
                    state:activeState || null
                }
            })

            lastAbort.current = abort
            let a = ((await data).topIssuerBondsDto || {}).topBondYieldValues || {}
            lastAbort.current = null

            let ks = []
            let ds = {}
            for (let [k, v] of Object.entries(a)) {
                ks.push(k)
                ds[k] = arrayFrom(v)
                    .filter(i => i.yieldValue>=0.0)
                    .map(i => {
                        let r = i.scatterOfferRow
                        r.x = i.maturityYearValue
                        r.y = i.yieldValue
                        r.maturityYearValue = i.maturityYearValue
                        r.yieldValue = i.yieldValue
                        r.rating = k
                        return r
                    })
                    .filter(a => (a.x<=30))
            }

            setOffersData(ds)

            let n = Object.values(ds).reduce( (n,a) => n+a.length, 0)
            if (n===0 && activeState) {
                setError(NO_RESULT)
                setStatus(Status.UNAVAILABLE)
                return
            }

            setStatus(Status.LOADED)

        } catch(e) {
            if (e.name==='AbortError') return
            if (lastAbort.current) lastAbort.current()
            setStatus(Status.FAILED_TO_LOAD)
        }

        })()

        return () => {
            if (lastAbort.current) lastAbort.current()
        }

    }, [activeState])

    return {
        offersData,
        offersStatus: status,
        offersError: error,
    }
}